// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeletedByMePayload__text-b5827b {
  display: flex;
  gap: 6px;
  color: var(--chat-bubble-text-secondary);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
}

.DeletedByMePayload__icon-cbc4d2 {
  min-width: min-content;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/components/MiniatureMessage/Payloads/DeletedByMePayload/DeletedByMePayload.styles.m.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,QAAA;EACA,wCAAA;EACA,4BAAA;EACA,8CAAA;AACF;;AAEA;EACE,sBAAA;AACF","sourcesContent":[".text {\n  display: flex;\n  gap: 6px;\n  color: var(--chat-bubble-text-secondary);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n}\n\n.icon {\n  min-width: min-content;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `DeletedByMePayload__text-b5827b`,
	"icon": `DeletedByMePayload__icon-cbc4d2`
};
module.exports = ___CSS_LOADER_EXPORT___;
